import { ENTITY_EXPERIMENT, ENTITY_SOP } from 'constants/schemas';
import NewExperimentForm, { useNewExperimentFormData } from 'components/NewExperimentForm';
import React, { useEffect, useState } from 'react';
import { formatType, getPath } from 'utils/entity.utils';

import { Dialog } from '@acheloisbiosoftware/absui.core';
import PropTypes from 'prop-types';
import { experimentActions } from 'store/entity';
import { getGenericId } from 'utils/generic.utils';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

function NewExperimentDialog(props) {
  const { open, onClose, initState } = props;
  const {
    formData,
    valid,
    resetFormData,
    updateFormData,
  } = useNewExperimentFormData(initState);

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (open) resetFormData();
  }, [open, resetFormData]);

  const _onClose = () => {
    resetFormData();
    onClose();
  };

  const onConfirm = () => {
    setLoading(true);
    dispatch(experimentActions.createExperiment(formData))
      .unwrap()
      .then((res) => {
        _onClose();
        navigate(getPath(getGenericId(res.result, ENTITY_EXPERIMENT)));
      })
      .finally(() => setLoading(false));
  };

  return (
    <Dialog
      title={`New ${formatType(ENTITY_EXPERIMENT, { template: formData?.is_template })}`}
      subtitle={`Execute an ${formatType(ENTITY_SOP, { lowercase: true })}-based ${formatType(ENTITY_EXPERIMENT, { lowercase: true })}.`}
      open={open}
      onClose={_onClose}
      confirmButtonText='Create'
      disableCloseOnConfirm
      maxWidth='md'
      fullWidth
      confirmDisabled={!valid}
      onConfirm={onConfirm}
      loading={loading}
    >
      <NewExperimentForm
        formData={formData}
        updateFormData={updateFormData}
      />
    </Dialog>
  );
}

NewExperimentDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  initState: PropTypes.object,
};

export default NewExperimentDialog;
